module.exports = __webpack_public_path__ + "img/album08_01.151fad01.jpg";